import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'beautifyList' })
export class BeautifyListPipe implements PipeTransform {
    transform(array: any): string {
        if(!Array.isArray(array)){
            return 'NA';
        }
        let resString = "";
        let firstRes = true;
        if(array)
        for (let value of array) {
            if(firstRes)
            {
                firstRes = false;
                resString = resString + value.name;
            }
            else
            resString = resString + "," + value.name;
        }
        const result = resString.replace(/,/g, ', ');;
        if(result === "")
            return "NA"
        else
            return result;
      }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/beautify-lis.pipe.ts